import { FC } from 'react';
import { InnerhivePage } from '../InnerhivePage';
import { Text } from '../components/Text';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CommunityTabsProvider } from './CommunityTabsProvider';
import { CareRecipientSwitcher } from '../navigation/CareRecipientSwitcher';
import { CareMapState } from '../caremap/CareMapState';
import { Redirect } from 'react-router';

export const CommunityNoCareMapPage: FC = () => {
    const tabsProvider = useInstance(CommunityTabsProvider);

    // if user logs out, they become anon and land on this page, then if they log back in to their
    // existing account with a care map, they end up back on this page, and we need to redirect
    const careMapState = useInstance(CareMapState);
    const recent = careMapState.getMostRecentCaremap();
    if (recent && !careMapState.isIncomplete(recent)) {
        return <Redirect to={`/community/${recent.careMapId}`} />;
    }

    return (
        <InnerhivePage
            data-id="community-empty-page"
            title="Community"
            tabs={tabsProvider.getTabs()}
        >
            <CareRecipientSwitcher trackingFrom="Community" />

            <p>
                <Text>
                    Once you've set up a care recipient, this is where you'll see who has access to their care and invite family, friends and helpers.
                </Text>
            </p>
        </InnerhivePage>
    );
};
